import React, { useState, useEffect } from 'react';
import moment from 'moment';
import swal from 'sweetalert2';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import TextareaAutosize from 'react-autosize-textarea';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../scss/components/pages/signin-management.scss';
import AddWorkTimeInSignInShiftBlock from '../../AddWorkTimeInSignInShiftBlock';
import LeaveRecDetail from '../../LeaveRecDetail';
import AddProductCategory from '../../AddProductCategory';
import AddCost from '../../AddCost';
import FileUploader from '../../FileUploader';
import _ from 'lodash';

import API from '../../../middleware/API';
import Pagination from '../../Pagination';
import { connect } from 'react-redux';
import { yearNames,GetStoreRole } from '../../../const/constant';

function IncomeStatement() {
  const [year, setYear] = useState(moment().add(-1,'month').year());
  const [month, setMonth] = useState(moment().add(-1,'month').month());
  const [costYear, setCostYear] = useState(moment().add(-1,'month').format('YYYY'));
  const [costMonth, setCostMonth] = useState(moment().add(-1,'month').format('M'));
  const [reload, doReload] = useState(false);
  const [switchPanel, setSwitchPanel] = useState(1);
  const [category, setCategory] = useState('-1');
  const [productIds, setProductIds] = useState('');
  const [isEditShow, setIsEditShow] = useState(false);
  const [isAddShow, setIsAddShow] = useState(false);
  const [file, setFile] = useState({});
  const [costFile, setCostFile] = useState({});
  const [productList, setProductList] =  useState({});
  const [costList, setCostList] =  useState({});
  const [productTypeList, setProductTypeList] =  useState([]);
  const [incomeStatement, setIncomeStatement] = useState({
    currentMonth:{weekIncome:[
        
    ]}
    
});

  const storeId =localStorage.getItem('current_store_id');

  function loadData() {
    var x = pad(parseInt(month, 10) + 1,2);
    API.get('/Chart/IncomeStatement?time='+year+'-'+x+'-01').then((response) => {
      if (response) {

        setIncomeStatement(response)

      }
    });

    API.get('/Product').then((response) => {
      //console.log(response)
    if (response) {
      setProductList(response)

    }})

    API.get('/Chart/IncomeStatementType').then((response) => {
      if (response) {
        setProductTypeList(response)
  
      }
    });

    API.get('/Chart/IncomeStatement?year='+costYear+'&month='+costMonth).then((response) => {
      if (response) {
        setCostList(response)
  
      }
    });
  }
  function pad(num, size) {
    if(num>12)
        num = 1;
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}
  useEffect(
    loadData,
    [ year, month, reload, costYear, costMonth],
  );
  function toggleAddBlockShow(){
    setIsAddShow(!isAddShow)
}
function toggleEditBlockShow(){
    setIsEditShow(!isEditShow)
}

function deleteCost(costId){
    console.log(costId)
    swal({
      type:'info',
      title: '是否確認刪除該筆資料',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        API.delete('/Chart/IncomeStatementCost?costId='+costId).then((response) => {
          if (response) {
            swal({type:'success',title:'刪除成功'}).then(()=>{
              doReload(!reload);
            })
          }
        })
      }
    });

  }
function selectTable() {
    selectElementContents(document.getElementById('myTable'));
  }
  function selectElementContents(el) {
    const { body } = document;
    let range;
    let sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
    }
    swal({
      type: 'info',
      title: '已複製到剪貼簿',
      showConfirmButton: false,
      showCloseButton: false,
      width: '250px',
      timer: 1000,
    });
    document.execCommand('Copy');
  }

  function submitInput(input,productIds){
    API.post('/Chart/Categoty/'+input+'/Product?productId='+productIds).then((response) => {

      setIsEditShow(false)
      alert('新增成功')
      
    });
  }

  function submitCostInput(input,itemName,transactionDate,amount,supplier,notes){
    var body = {
        TypeId: input,
        ItemName: itemName,
        TransactionDate:transactionDate,
        Amount:amount,
        Supplier:supplier,
        Notes:notes
    }
    API.post('/Chart/IncomeStatementCost', body).then((response) => {

      setIsAddShow(false)
      swal({
        type: 'success',
        title: '新增成本成功',
        showConfirmButton: false,
        showCloseButton: false,
        width: '250px',
        timer: 1000,
      });
      doReload(!reload)
    });
  }

    function handleSelectFile(event) {
    setFile(event);
  }
  function handleSelectCostFile(event) {
    setCostFile(event);
  }
  function submitForm(){
    if (typeof file.size !== 'undefined'){
      const formData = new FormData();
      formData.append("File", file);
      API.post('Chart/Product', formData).then((response) => {
        if (response) {
  
          swal({
            type: 'success',
            title: '上傳成功',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
          
  
        }else{
          swal({
            type: 'error',
            title: '資料錯誤，請聯絡工程師。',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
        }
      });
    }else{
      swal({
        type: 'warning',
        title: '尚未選取檔案',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      })    }
    
  }
  function submitCostForm(){
    if (typeof costFile.size !== 'undefined'){
      const formData = new FormData();
      formData.append("File", costFile);
      API.post('Chart/Cost', formData).then((response) => {
        if (response) {
  
          swal({
            type: 'success',
            title: '上傳成功',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
          
  
        }else{
          swal({
            type: 'error',
            title: '資料錯誤，請聯絡工程師。',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
        }
      });
    }else{
      swal({
        type: 'warning',
        title: '尚未選取檔案',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      })    }
    
  }
  function showUnknownProduct(){
    API.get('/CategoryProduct').then((response) => {
        var productList = '';

        response.forEach((item)=>{

            productList = productList+item.productCode+'-'+item.productName+'<br/>'
        })

        swal({
            type: 'warning',
            title: '尚未分類品項:',
            html: productList,
            showCloseButton: true,
            heightAuto: false,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#A9ABA8',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          })

      
    });
  }
  function generateExcel() {
//     swal({
//       type: 'warning',
//       title: '確定更新報表?',
//       text: '所有出勤資料將會清除並重新計算。',
//       showCloseButton: true,
//       heightAuto: false,
//       showCancelButton: true,
//       showConfirmButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#A9ABA8',
//       confirmButtonText: '確定',
//       cancelButtonText: '取消',
//     }).then((result) => {
//       if (result.value) {
//         axios({
//           url:process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/'+'/Chart/Generate?year='+year+'&month='+(parseInt(month, 10)+1):'https://www.liangshishu.link:46888/api/'+'/Chart/Generate?year='+year+'&month='+(parseInt(month, 10)+1),
//           method: 'GET',
//           headers:{
// 'Authorization': 'bearer ' + localStorage.getItem('access_token'),
//       'StoreId':storeId },
//       responseType: 'blob'}).then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', '出勤明細'+year+'年'+(parseInt(month, 10)+1)+'月_' + new Date().toLocaleDateString() +'.xlsx'); //or any other extension
//           document.body.appendChild(link);
//           link.click();
//           });
//       }
//     })

  }

 
  var xlsnBtn = <button className="btn btn-md edit m-r-16" onClick={() => { generateExcel(); } }>複製報表</button>;

  var tableHead = '';
  
  var costBody = '';

  var tableBody = '';
  var productBody = '';
  if( typeof productList !== 'undefined'&&productList.length>0 ){

    if(category == '-1'){
      productBody =
      <tbody>{
        productList.map((item, index)=>{
          return <tr key={index}>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productCode}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productName}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.categoryId == 1 ? '餐食':
            item.categoryId == 2 ? '飲料':
            item.categoryId == 3 ? '甜點':
            item.categoryId == 4 ? '包場':
            item.categoryId == 5 ? '商品':
            item.categoryId == 6 ? '其他':'未分類'
            }</td>
          
          </tr>
      })
        }
  
     </tbody>
    }else if(category == '7'){
      productBody =
      <tbody>{
        productList.filter(item=>item.categoryId == null || item.categoryId == 7).map((item, index)=>{
          return <tr >
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productCode}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productName}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.categoryId == 1 ? '餐食':
            item.categoryId == 2 ? '飲料':
            item.categoryId == 3 ? '甜點':
            item.categoryId == 4 ? '包場':
            item.categoryId == 5 ? '商品':
            item.categoryId == 6 ? '其他':'未分類'
            }</td>
          
          </tr>
      })
        }
  
     </tbody>

    }else{
      productBody =
      <tbody>{
        productList.filter(item=>item.categoryId == category).map((item, index)=>{
          return <tr >
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productCode}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.productName}</td>
            <td style={{color:item.categoryId == null?'red':'black'}}>{item.categoryId == 1 ? '餐食':
            item.categoryId == 2 ? '飲料':
            item.categoryId == 3 ? '甜點':
            item.categoryId == 4 ? '包場':
            item.categoryId == 5 ? '商品':
            item.categoryId == 6 ? '其他':'未分類'
            }</td>
          
          </tr>
      })
        }
  
     </tbody>
    }

  }
  if(typeof costList !== 'undefined' && costList.length > 0){
    costBody=<tbody>{
        costList.map((item)=>{
            return(

                <tr>
                    <td>{item.typeName}</td>
                    <td>{item.itemName}</td>
                    <td>{item.amount}</td>
                    <td>{item.transactionDate.split('T')[0]}</td>
                    <td>{item.supplier || ''}</td>
                    <td>{item.note || ''}</td>
                    <td><button className='btn btn-md delete' onClick={e=>deleteCost(item.id)}>刪除</button></td>
                </tr>
            )

        })
        }
  
     </tbody>
  }

  if( typeof incomeStatement !== 'undefined'&&incomeStatement.currentMonth.weekIncome.length>0 ){
    var monStr = parseInt(month, 10) + 1;
    var nextMonStr = parseInt(month, 10) + 2;
    if(nextMonStr > 12)
        nextMonStr = '01'

    tableHead =   
    <thead>
    <tr key={335}>
        <th key={3351}></th>
        <th key={3352} colSpan={2}>項次</th>
        {
        incomeStatement.currentMonth.weekIncome.map((item, index)=>{
            return <th key={3355+index}>{monStr}月第{index+1}週</th>
        })
    }
    <th key={3353}>{monStr}月總計</th>
    {
        incomeStatement.nextMonth.weekIncome.map((item, index)=>{
            return <th key={3365+index}>{nextMonStr}月第{index+1}週</th>
        })
    }
    <th key={3354}>{nextMonStr}月總計</th>
    </tr>
    </thead>


    tableBody = <tbody>
    <tr key={1}>
        <td rowSpan={6}>營運收入</td>
        <td colSpan={2}>餐食</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item, index)=>{
                return  <td key={3365+index}>{item.foodIncome}</td>
            })
        }
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {foodIncome}) => n + foodIncome, 0)}</td>       
        {
            incomeStatement.nextMonth.weekIncome.map((item, index)=>{
                return  <td key={3365+index}>{item.foodIncome}</td>
            })
        }
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {foodIncome}) => n + foodIncome, 0)}</td>         
    </tr>
    <tr key={2}>
        <td colSpan={2}>飲料</td>             
        {
            incomeStatement.currentMonth.weekIncome.map((item, index)=>{
                return  <td key={3365+index}>{item.drinkIncome}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {drinkIncome}) => n + drinkIncome, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td>{item.drinkIncome}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {drinkIncome}) => n + drinkIncome, 0)}</td>  
    </tr>
    <tr key={3}>
        <td colSpan={2}>甜點</td>             
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td>{item.dessertIncome}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {dessertIncome}) => n + dessertIncome, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td>{item.dessertIncome}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {dessertIncome}) => n + dessertIncome, 0)}</td>  
    </tr>
    <tr key={4}>
        <td colSpan={2}>包場</td>             
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td>{item.fieldIncome}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {fieldIncome}) => n + fieldIncome, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td>{item.fieldIncome}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {fieldIncome}) => n + fieldIncome, 0)}</td>  
    </tr>
    <tr key={41}>
        <td colSpan={2}>商品</td>             
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td>{item.productIncome}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {productIncome}) => n + productIncome, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td>{item.productIncome}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {productIncome}) => n + productIncome, 0)}</td>  
    </tr>
    <tr key={42}>
        <td colSpan={2}>其他</td>             
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td>{item.otherIncome}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {otherIncome}) => n + otherIncome, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td>{item.otherIncome}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {otherIncome}) => n + otherIncome, 0)}</td>  
    </tr>
    <tr>
        <td colSpan={3}>小計</td>
        {
        incomeStatement.currentMonth.weekIncome.map((item)=>{
            return  <td>{item.foodIncome +
                item.drinkIncome +
                item.dessertIncome +
                item.fieldIncome+
                item.productIncome+
                item.otherIncome }</td>
        })               
        }
        <td>{incomeStatement.currentMonth.weekIncome.reduce((sum, item) => sum + item.foodIncome + item.drinkIncome + item.dessertIncome + item.fieldIncome+ item.productIncome+item.otherIncome, 0)}</td>  

{
        incomeStatement.nextMonth.weekIncome.map((item)=>{
            return  <td>{item.foodIncome +
                item.drinkIncome +
                item.dessertIncome +
                item.fieldIncome+
                item.productIncome+
                item.otherIncome}</td>
        })               
        }
        <td>{incomeStatement.nextMonth.weekIncome.reduce((sum, item) => sum + item.foodIncome + item.drinkIncome + item.dessertIncome + item.fieldIncome+ item.productIncome+item.otherIncome, 0)}</td>  

    </tr>
    <tr key={5}>
        <td rowSpan={18}>營業成本分項<br/>/成本佔比%</td>    
        <td rowSpan={4}>變動成本<br/>食材成本</td>             
        <td>餐食</td>   
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.foodCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {foodCost}) => n + foodCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.foodCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {foodCost}) => n + foodCost, 0)}</td>             
    </tr>
    <tr key={6}>
        <td>飲料</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.drinkCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {drinkCost}) => n + drinkCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.drinkCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {drinkCost}) => n + drinkCost, 0)}</td>   
    </tr>
    <tr key={7}>
        <td>甜點</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.dessertCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {dessertCost}) => n + dessertCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.dessertCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {dessertCost}) => n + dessertCost, 0)}</td>   
    </tr>
    <tr key={7}>
        <td>餐飲週邊耗材</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.consumableCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {consumableCost}) => n + consumableCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.consumableCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {consumableCost}) => n + consumableCost, 0)}</td>   
    </tr>
    <tr key={8}>
        <td rowSpan={6}>人事費用<br/>正職PT</td>  
        <td>內場</td>     
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {inFieldCost}) => n + inFieldCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {inFieldCost}) => n + inFieldCost, 0)}</td>           
    </tr>
    <tr key={212}>
        <td>內場兼職</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {inFieldPartTimeCost}) => n + inFieldPartTimeCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {inFieldPartTimeCost}) => n + inFieldPartTimeCost, 0)}</td>      
    </tr>
    <tr key={9}>
        <td>吧檯</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {barCost}) => n + barCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {barCost}) => n + barCost, 0)}</td>      
    </tr>
    <tr key={213}>
        <td>吧檯兼職</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {barPartTimeCost}) => n + barPartTimeCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {barPartTimeCost}) => n + barPartTimeCost, 0)}</td>      
    </tr>
    <tr key={10}>
        <td>外場</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {outFieldCost}) => n + outFieldCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {outFieldCost}) => n + outFieldCost, 0)}</td>      
    </tr>
    <tr key={21}>
        <td>外場兼職</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {outFieldPartTimeCost}) => n + outFieldPartTimeCost, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldPartTimeCost}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {outFieldPartTimeCost}) => n + outFieldPartTimeCost, 0)}</td>      
    </tr>
    <tr key={11}>
        <td rowSpan={6}>營業雜項<br/>費用</td>
        <td>租金</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.rentalFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {rentalFee}) => n + rentalFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.rentalFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {rentalFee}) => n + rentalFee, 0)}</td>   
    </tr>
    <tr key={12}>
        <td>管理費</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.managementFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {managementFee}) => n + managementFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.managementFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {managementFee}) => n + managementFee, 0)}</td>   
    </tr>
    <tr key={13}>
        <td>水電</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.waterPowerFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {waterPowerFee}) => n + waterPowerFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.waterPowerFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {waterPowerFee}) => n + waterPowerFee, 0)}</td>   
    </tr>
    <tr key={14}>
        <td>瓦斯</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.gasFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {gasFee}) => n + gasFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.gasFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {gasFee}) => n + gasFee, 0)}</td>   
    </tr>
    <tr key={15}>
        <td>稅捐</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.taxFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {taxFee}) => n + taxFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.taxFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {taxFee}) => n + taxFee, 0)}</td>   
    </tr>
    <tr key={16}>
        <td>保險</td>
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.insuranceFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {insuranceFee}) => n + insuranceFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.insuranceFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {insuranceFee}) => n + insuranceFee, 0)}</td>   
    </tr>
    <tr key={17}>
        <td>行銷成本</td><td>印刷等</td>     
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.prdecimalFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {prdecimalFee}) => n + prdecimalFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.prdecimalFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {prdecimalFee}) => n + prdecimalFee, 0)}</td>          
    </tr>
    <tr key={18}>
        <td colSpan={2}>其他攤提</td>  
        {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.otherFee}</td>
            })
        } 
        <td>{incomeStatement.currentMonth.weekIncome.reduce((n, {otherFee}) => n + otherFee, 0)}</td>             
        {
            incomeStatement.nextMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.otherFee}</td>
            })
        } 
        <td>{incomeStatement.nextMonth.weekIncome.reduce((n, {otherFee}) => n + otherFee, 0)}</td>               
    </tr>
    <tr key={30}>
    <td rowSpan={6}>績效分析</td>            
    <td rowSpan={6}>工時</td>            
          <td>內場工時</td>          
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {inFieldHours}) => n + inFieldHours*10, 0)/10)}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {inFieldHours}) => n + inFieldHours*10, 0)/10)}</td>      
    </tr>
    <tr key={31}>
          <td>內場兼職工時</td> 
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldPartTimeHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {inFieldPartTimeHours}) => n + inFieldPartTimeHours*10, 0)/10)}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.inFieldPartTimeHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {inFieldPartTimeHours}) => n + inFieldPartTimeHours*10, 0)/10)}</td>               
    </tr>
    <tr key={32}>
          <td>吧檯工時</td>  
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {barHours}) => n + barHours*10, 0)/10)}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {barHours}) => n + barHours*10, 0)/10)}</td>              
    </tr>
    <tr key={33}>
          <td>吧檯兼職工時</td>
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barPartTimeHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {barPartTimeHours}) => n + barPartTimeHours*10, 0))/10}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.barPartTimeHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {barPartTimeHours}) => n + barPartTimeHours*10, 0)/10)}</td>                
    </tr>
    <tr key={34}>
          <td>外場工時</td>    
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {outFieldHours}) => n + outFieldHours*10, 0)/10)}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {outFieldHours}) => n + outFieldHours*10, 0)/10)}</td>            
    </tr>
    <tr key={35}>
          <td>外場兼職工時</td> 
          {
            incomeStatement.currentMonth.weekIncome.map((item)=>{
                return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldPartTimeHours}</td>
            })
          } 
          <td>{(incomeStatement.currentMonth.weekIncome.reduce((n, {outFieldPartTimeHours}) => n + outFieldPartTimeHours*10, 0)/10)}</td>             
          {
              incomeStatement.nextMonth.weekIncome.map((item)=>{
                  return  <td style={{color: item.isActual ? 'black' : 'blue'}}>{item.outFieldPartTimeHours}</td>
              })
          } 
          <td>{(incomeStatement.nextMonth.weekIncome.reduce((n, {outFieldPartTimeHours}) => n + outFieldPartTimeHours*10, 0)/10)}</td>               
    </tr>
    </tbody>
  }

  return (
    
    <div className="p-signInManagement">
  <div className="u-tag_group">
    <a className={switchPanel === 1 ? 'tag active' : 'tag'} onClick={() => { setSwitchPanel(1); }} >損益表</a>
    <a className={switchPanel === 2 ? 'tag active' : 'tag'} onClick={() => { setSwitchPanel(2); }} >產品分類表</a>
    <a className={switchPanel === 3 ? 'tag active' : 'tag'} onClick={() => { setSwitchPanel(3); }} >成本清單</a>
  </div>
      <div className="u-block" style={{ display: switchPanel === 1 ? 'block' : 'none'}}>
        <div className="u-title">
        {/* <a
              href="https://docs.google.com/presentation/d/10RB5_svavZPkS8Q5sjXplIOOxgqZLZGBX1CqIbMNpl0/edit#slide=id.g10b0e509c7e_0_45"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a> */}
        </div>

        <div className="sign-notice">
        <div className="u-notice">*溫馨提醒: </div>
        <div className="u-notice">執行上傳後，系統會自動新增新品項，之後到產品分類表使用下拉選單選擇<button
              type="button"
              className={`btn btn-md edit`}
            >未分類</button>查看未分類品項編號，再用<button
            type="button"
            className={`btn btn-md save`}
          >品項分類</button>進行分類。 </div>
        <div className="u-notice">人事成本是以排班總時間或實際打卡總時間乘上人員時薪，如遇假日則是再兩倍，此規則進行估算 </div>
        <div className="u-notice">如果遇到員工所屬職稱改動或者移除職稱則無法分類到部門，會造成誤差。 </div>

        </div>
        <div className="u-search-box">
          <div className="u-search-box_left">
          <button type="button" className="btn btn-md save m-l-8" onClick={toggleAddBlockShow}>新增成本</button>

            <div className="date-input">
              <select onChange={(e)=>{setYear(e.target.value)}} value={year} className="u-form__select">
              {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>{ yearName }</option>
                ))
              }
              </select>
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>年</span>

            </div>
            <div className="date-input">
              <select onChange={(e)=>{setMonth(e.target.value)}}  value={month} className="u-form__select">

                        {
                Array.from({ length: 12 }, (_, month) => (
                    <option value={month} key={month}>
                        {month + 1}
                    </option>
                ))
                }
              </select>
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>月</span>

            </div>
            
          {/* {xlsnBtn} */}
          <button type="button" className="btn btn-md success m-l-8" onClick={selectTable}>全選複製</button>

          </div>
          <div className="u-search-box_right">
          <div className="date-input" style={{backgroundColor:'lightgray'}}>
          <FileUploader
            onFileSelectSuccess={handleSelectFile}
            onFileSelectError={({ error }) => alert(error)}
            />
            <button type='button' onClick={submitForm}>上傳銷售紀錄</button>
          </div>
          </div>
        </div>
        <div className="u-table-responsive">
          <table className="u-table u-table-striped" id="myTable">
            {tableHead}
            {tableBody}
           
          </table>
        </div>

      </div>

      <div className="u-block" style={{ display: switchPanel === 2 ? 'block' : 'none'}}>
      <div className="u-search-box">
          <div className="u-search-box_left">
          <button type="button" className="btn btn-md save m-l-8" onClick={toggleEditBlockShow}>品項分類</button>

           <span className="mobile-hide"style={{ flex: '0 0 0px' }}>商品分類：</span>

            <select style={{minWidth:"56px"}} value={category} onChange={(e)=>{
                setCategory(e.target.value)

                }} className="u-form__select">
            <option  value={'-1'} key={-1}>全部</option>
            <option key={1} value={'1'}>餐食</option>
            <option key={2} value={'2'}>飲料</option>
            <option key={3} value={'3'}>甜點</option>
            <option key={4} value={'4'}>包場</option>
            <option key={5} value={'5'}>商品</option>
            <option key={6} value={'6'}>其他</option>
            <option key={7} value={'7'}>未分類</option>
            </select> 
          </div>
        </div>
      <div className="u-table-responsive">
          <table className="u-table u-table-striped" id="myTable">
          <thead>
            <tr>
              <th scope="col">產品編號</th>
              <th scope="col">產品名稱</th>
              <th scope="col">所屬分類</th>
            </tr>
          </thead>
              {productBody}
          </table>
        </div>
      </div>
      <div className="u-block" style={{ display: switchPanel === 3 ? 'block' : 'none'}}>
      <div className="u-search-box">
          <div className="u-search-box_left">

          <button type="button" className="btn btn-md save m-l-8" onClick={toggleAddBlockShow}>新增成本</button>


            <select style={{minWidth:"70px"}} value={costYear} onChange={(e)=>{
                setCostYear(e.target.value)

                }} className="u-form__select">
            {
              yearNames.map(yearName => (
                <option key={yearName} value={yearName}>{ yearName }</option>
              ))
            }
            </select> 
            <span className="mobile-hide"style={{ flex: '0 0 0px' }}>年</span>


                <select style={{minWidth:"56px"}} value={costMonth} onChange={(e)=>{
                    setCostMonth(e.target.value)

                    }} className="u-form__select">
                <option key={1} value={'1'}>1</option>
                <option key={2} value={'2'}>2</option>
                <option key={3} value={'3'}>3</option>
                <option key={4} value={'4'}>4</option>
                <option key={5} value={'5'}>5</option>
                <option key={6} value={'6'}>6</option>
                <option key={7} value={'7'}>7</option>
                <option key={8} value={'8'}>8</option>
                <option key={9} value={'9'}>9</option>
                <option key={10} value={'10'}>10</option>
                <option key={11} value={'11'}>11</option>
                <option key={12} value={'12'}>12</option>
                </select> 
                <span className="mobile-hide"style={{ flex: '0 0 0px' }}>月</span>

          </div>
          <div className="u-search-box_right">
          <div className="date-input" style={{backgroundColor:'lightgray'}}>
          <FileUploader
            onFileSelectSuccess={handleSelectCostFile}
            onFileSelectError={({ error }) => alert(error)}
            />
            <button type='button' onClick={submitCostForm}>上傳成本紀錄</button>
          </div>
          </div>
          </div>
          <div className="u-table-responsive">
          <table className="u-table u-table-striped" id="myTable">
          <thead>
          <tr>
              <th scope="col">所屬分類</th>
              <th scope="col">名稱</th>
              <th scope="col">金額</th>
              <th scope="col">日期</th>
              <th scope="col">供應商</th>
              <th scope="col">備註</th>
              <th></th>
            </tr>
          </thead>
              {
                costBody
              }
          </table>
        </div>
      </div>
      <AddProductCategory
            isShow={isEditShow}
            editInformation={productIds}
            saveFunc={submitInput}
            toggleFunc={toggleEditBlockShow}
          />
    <AddCost
            isShow={isAddShow}
            productTypeList={productTypeList || []}
            saveFunc={submitCostInput}
            toggleFunc={toggleAddBlockShow}
          />
      {/* <LeaveRecDetail 
            leaveRec={targetLeaveRec}
            isShow={isLeaveRecDetailDisplay}
            toggleFunc={toggleLeaveRecDetailDisplay}
          />
      <AddWorkTimeInSignInShiftBlock 
          isSalaryEdit={true}
          isVisible={isAddWorkTimeOpen} 
          toggleOpen={()=>{setIsAddWorkTimeOpen(false)}} 
          allStaff={staffList} 
          editStaff={editStaff}
          saveWorkRecordFunc={handleAddStaffWorkRecord}
        /> */}
    </div>
  );
}

export default IncomeStatement;
